import React from 'react';
import { ProductPreviewTemplate } from 'themes/application/product/pages';
import { observer } from 'mobx-react';
import { ProductPreviewViewStore } from 'application/product/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ProductPreviewViewStore(rootStore), 'productPreviewViewStore')
@observer
class ProductPreview extends React.Component {
    render() {
        return <ProductPreviewTemplate {...this.props} />
    }
}

export default ProductPreview;